import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const SLIDES = [
  {
    img: "/assets/hero-onboard-1.jpg",
    line1: "Apna Live.",
    line2pre: "Apne ",
    line2gold: "Yaara.",
    sub: "India ka apna premium live stage",
    cta: "Shuru Karein",
  },
  {
    img: "/assets/hero-onboard-2.jpg",
    line1: "Gifts bhejo.",
    line2pre: "Pyaar ",
    line2gold: "jeeto.",
    sub: "Roses, teddies aur supercars — live magic on stage",
    cta: "Aage Badhein",
  },
  {
    img: "/assets/hero-onboard-3.jpg",
    line1: "1:1 Calls.",
    line2pre: "Real ",
    line2gold: "Yaari.",
    sub: "Apne favourite creator se seedhi baat karo",
    cta: "Chalo, Live Chalein",
  },
];

export default function Welcome() {
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();
  const slide = SLIDES[idx];
  const last = idx === SLIDES.length - 1;

  const done = () => {
    localStorage.setItem("yaara_welcomed", "1");
    navigate("/login", { replace: true });
  };
  const next = () => (last ? done() : setIdx((i) => i + 1));

  return (
    <div className="h-screen-dvh max-w-md mx-auto relative overflow-hidden flex flex-col bg-[#0B0B14]" data-testid="welcome-screen">
      <AnimatePresence mode="wait">
        <motion.div key={idx} className="absolute inset-0"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.45 }}>
          <motion.img src={slide.img} alt=""
            className="absolute inset-x-0 top-0 w-full h-[72%] object-cover object-top"
            initial={{ scale: 1.06 }} animate={{ scale: 1 }} transition={{ duration: 5, ease: "easeOut" }} />
          <div className="absolute inset-x-0 top-0 h-[72%]"
            style={{ background: "linear-gradient(to bottom, rgba(11,11,20,0.15) 0%, transparent 20%, transparent 45%, rgba(11,11,20,0.85) 78%, #0B0B14 100%)" }} />
        </motion.div>
      </AnimatePresence>

      <div className="relative z-10 flex justify-end px-6 pt-[max(1.5rem,env(safe-area-inset-top))]">
        {!last && (
          <button data-testid="welcome-skip" onClick={done} className="text-white/70 text-[15px] font-semibold px-2 py-1">
            Skip
          </button>
        )}
      </div>

      <div className="flex-1" />

      <AnimatePresence mode="wait">
        <motion.div
          key={idx}
          className="relative z-10 px-7"
          initial={{ opacity: 0, y: 26 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -14 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          drag="x" dragConstraints={{ left: 0, right: 0 }} dragElastic={0.2}
          onDragEnd={(_, info) => {
            if (info.offset.x < -70) next();
            else if (info.offset.x > 70 && idx > 0) setIdx((i) => i - 1);
          }}
        >
          <h1 className="font-serif-display font-bold text-[40px] leading-[1.12] text-white">
            {slide.line1}
            <br />
            {slide.line2pre}<span className="text-[#FFD86B]">{slide.line2gold}</span>
          </h1>
          <p className="text-[#B8B0C9] text-[15px] leading-[22px] mt-3">{slide.sub}</p>
        </motion.div>
      </AnimatePresence>

      <div className="relative z-10 px-7 pt-7 pb-[max(2.25rem,env(safe-area-inset-bottom))]">
        <div className="flex gap-2 mb-6">
          {SLIDES.map((_, i) => (
            <button
              key={i} data-testid={`welcome-dot-${i}`} onClick={() => setIdx(i)}
              className={`h-2 rounded-full transition-all duration-300 ${i === idx ? "w-6 bg-[#FFD86B]" : "w-2 bg-white/20"}`}
            />
          ))}
        </div>
        <motion.button
          data-testid="welcome-next"
          onClick={next}
          whileTap={{ scale: 0.97 }}
          className="w-full btn-gradient text-[16px] py-4"
        >
          {slide.cta}
        </motion.button>
      </div>
    </div>
  );
}
